import * as headerConstants from './actionTypes';
import {config} from '../../config/config';
import request from '../../components/Helper/Request';

const userDetails = JSON.parse(window.sessionStorage.getItem("userInfo"));

export const getHeaderList = (limit,page) => {
    return (dispatch) => {
      dispatch({
        type: headerConstants.FETCH_HEADER_LIST
      });

      request({
          method: 'get',
          url:`${config.API_URL}/api/email-section-configurations`,
          params: {
              limit,
              page,
              sortOrder : "desc",
              sortBy: "modifiedTime"
          }
      })
        .then((response) => { 
          dispatch({
            type: headerConstants.FETCH_HEADER_LIST_SUCCESS,
            payload: response && response.filter(e=> {return e.sectionType==='HEADER'})
          });
        })
        .catch((error) => {
          dispatch({
            type: headerConstants.FETCH_HEADER_LIST_FAILURE,
            payload:error
          });
        })
    }
  
}

export const createHeader =(headerData) =>{

    const data = {...headerData,  
      createdBy: userDetails?.emailId,
      modifiedBy: userDetails?.emailId
    }; 
    return (dispatch) => {
    dispatch({
        type: headerConstants.CREATE_HEADER
    });

    request({
        method: 'post',
        url:`${config.API_URL}/api/email-section-configurations`,   
        data
    })
    .then((response) => {
        dispatch({
        type: headerConstants.CREATE_HEADER_SUCCESS,
        payload: response
        });
    }).catch((error) => {
        dispatch({
        type: headerConstants.CREATE_HEADER_FAILURE,
        payload:error?.response?.data
        });
    });
    }
}

export const editHeader =(headerData) =>{
        
  const data = {
    ...headerData,
    modifiedBy: userDetails?.emailId
  }; 

  return (dispatch) => {
  dispatch({
      type: headerConstants.EDIT_HEADER
  });

  request({
      method: 'put',
      url:`${config.API_URL}/api/email-section-configurations/${data.code}`,
      data
  })
  .then((response) => {
      dispatch({
      type: headerConstants.EDIT_HEADER_SUCCESS,
      payload: response
      });
  }).catch((error) => {

      dispatch({
      type: headerConstants.EDIT_HEADER_FAILURE,
      payload:error?.response?.data
      });
  });
  }
}

export const deleteHeader =(headerData) =>{
        
  const data = {
    ...headerData,
    modifiedBy: headerData?.modifiedBy
  }; 

  return (dispatch) => {
  dispatch({
      type: headerConstants.DELETE_HEADER
  });

  request({
      method: 'delete',
      url:`${config.API_URL}/api/email-section-configurations/${data.code}`
  })
  .then(() => {
      dispatch({
      type: headerConstants.DELETE_HEADER_SUCCESS,
      payload: {status: 1}
      });
  }).catch(() => {
      dispatch({
      type: headerConstants.DELETE_HEADER_FAILURE,
      payload:{status: 0}
      });
  });
  }
}
export const resetEditHeaderConfigData = () => {
return (dispatch) => {
  dispatch({
      type: headerConstants.RESET_EDIT_HEADER_CONFIG_STATE
  });  
  }
}

export const resetCreateHeaderConfigData = () => {
return (dispatch) => {
  dispatch({
      type: headerConstants.RESET_CREATE_HEADER_CONFIG_STATE
  });  
  }
}